var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { content: "container-fluid pt-4" } },
    [
      _c("div", { staticClass: "subheader" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "subheader-block d-lg-flex align-items-center" },
          [
            _c(
              "div",
              {
                staticClass:
                  "d-inline-flex flex-column justify-content-center mr-3",
              },
              [
                _c("span", { staticClass: "fw-300 fs-xs d-block opacity-50" }, [
                  _c("small", [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm.__t("ORDERS")) +
                        "\n\t\t\t\t\t"
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "fw-500 fs-xl d-block color-primary-500" },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t" + _vm._s(_vm.animatedOrders) + "\n\t\t\t\t"
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "span",
              [
                _c("peity", {
                  attrs: {
                    type: "bar",
                    options: {
                      width: 50,
                      fill: ["#886ab5"],
                      height: 32,
                      innerRadius: 10,
                      radius: 40,
                    },
                    data: _vm.order_data.count_by_day.toString(),
                  },
                }),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "subheader-block d-lg-flex align-items-center border-faded border-right-0 border-top-0 border-bottom-0 ml-3 pl-3",
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "d-inline-flex flex-column justify-content-center mr-3",
              },
              [
                _c("span", { staticClass: "fw-300 fs-xs d-block opacity-50" }, [
                  _c("small", [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm.__t("TOTAL_SUM")) +
                        "\n\t\t\t\t\t"
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "fw-500 fs-xl d-block color-success-500" },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm._f("toCurrency")(_vm.animatedSum)) +
                        "\n\t\t\t\t"
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "span",
              [
                _c("peity", {
                  attrs: {
                    type: "line",
                    options: {
                      width: 50,
                      fill: ["#1dc9b7"],
                      height: 32,
                      innerRadius: 10,
                      radius: 40,
                    },
                    data: _vm.order_data.order_sum_day.toString(),
                  },
                }),
              ],
              1
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("orders_heatmap"),
      _vm._v(" "),
      _c(
        "b-overlay",
        { staticClass: "pt-4", attrs: { rounded: "sm" } },
        [
          _c("b-card", { staticClass: "text-left rounded-plus" }, [
            _c("div", { staticClass: "wrap pt-0" }, [
              _c("div", {}, [
                _c(
                  "span",
                  {
                    staticClass:
                      "badge position-relative mr-2 fs-xl bg-none text-warning",
                  },
                  [_c("i", { staticClass: "fal fa-edit" })]
                ),
                _vm._v(
                  "\n\t\t\t\t\t" + _vm._s(_vm.__t("SELECT_DATE")) + "\n\t\t\t\t"
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-6 col-xs-6 pt-4" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-6" },
                      [
                        _c("b-form-datepicker", {
                          attrs: { locale: "ru-RU" },
                          on: { context: _vm.onContext },
                          model: {
                            value: _vm.date,
                            callback: function ($$v) {
                              _vm.date = $$v
                            },
                            expression: "date",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-overlay",
        { staticClass: "pt-4", attrs: { rounded: "sm" } },
        [
          _c(
            "b-card",
            { staticClass: "text-left rounded-plus" },
            [
              _c(
                "b-row",
                {},
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12", lg: "6", sm: "12", md: "6" } },
                    [_c("bank")],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12", lg: "6", sm: "12", md: "6" } },
                    [_c("month_pay")],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-overlay",
        { staticClass: "pt-4", attrs: { rounded: "sm" } },
        [
          _c(
            "b-card",
            { staticClass: "text-left rounded-plus" },
            [
              _c(
                "b-row",
                {},
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12", lg: "6", sm: "12", md: "6" } },
                    [_c("cur_load")],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12", lg: "6", sm: "12", md: "6" } },
                    [_c("all_orders")],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-overlay",
        { staticClass: "pt-4", attrs: { rounded: "sm" } },
        [
          _c(
            "b-card",
            { staticClass: "text-left rounded-plus" },
            [
              _c(
                "b-row",
                {},
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [_c("stop_list_duration")],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", { staticClass: "subheader-title" }, [
      _c("i", { staticClass: "subheader-icon fal fa-chart-area" }),
      _vm._v("\n\t\t\tAnalytics"),
      _c("span", { staticClass: "fw-300" }, [_vm._v("Dashboard")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }